import { Component, inject, OnDestroy } from "@angular/core";
import { RouterOutlet } from "@angular/router";
import { SharedStore } from "../../../shared/stores/shared.store";

@Component({
    selector: 'app-group-layout',
    template: `
        <router-outlet></router-outlet>
    `,
    imports: [RouterOutlet]
})
export class GroupLayout implements OnDestroy {
    private readonly sharedStore = inject(SharedStore);

    ngOnDestroy() {
        this.sharedStore.clearGroupFilters();
    }
}